<template>
  <!-- Ringba Integration Banner -->
  <b-alert
    show
    variant="info"
    class="m-4 ringba-integration-banner"
  >
    <h6 class="mb-2">
      <font-awesome-icon
        :icon="['fas', 'info-circle']"
        class="mr-2"
      />
      Introducing Ringba Integration
    </h6>
    <p class="mb-2">
      To facilitate Ring Tree Target (RTT) creation for your approved offers, please setup Ringba integration.
    </p>
    <router-link
      :to="{ name: 'RingbaIntegration' }"
      class="btn btn-sm btn-primary"
    >
      Setup Ringba Integration
    </router-link>
  </b-alert>
</template>

<script>
export default {
  name: 'RingbaIntegrationBanner'
}
</script>

<style lang="scss" scoped>
.ringba-integration-banner {
  margin-bottom: 0 !important;
}
</style>